export const isVisible = (domElement: HTMLElement) => {
    return new Promise((resolve) => {
        const o = new IntersectionObserver(([entry]) => {
            resolve(entry.intersectionRatio === 1);
            o.disconnect();
        });
        o.observe(domElement);
    });
};
